import jwtDecode from "jwt-decode";
import moment from "moment";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import { noContentElementInitialState } from "../../../../common/utils/helpers";

export const LOCAL_STORAGE_TOKEN_KEY = "token";

export const LOCAL_STORAGE_REF_TOKEN_KEY = "referentielToken";
export const IS_VALIDE = "nonValide";
export const IS_SUSPENDU = "suspendu";
export const HAS_SOLDE = "soldeNegatif";
export const LASTNAME = "lastname";
export const FIRSTNAME = "firstname";



const getTokenData = () => {
  const emptyReturn = { user: null, token: null };
  const token = sessionStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
  if (Boolean(token)) {
    const parsedToken = jwtDecode(token);
    if (parsedToken?.exp && moment.unix(parsedToken.exp).isBefore(moment())) {
      sessionStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
      return emptyReturn;
    }
    return { token, user: parsedToken };
  }
  return emptyReturn;
};

const initialState = {
  ...getTokenData(),
  hasBeenLoggedOut: false,
  ...noContentElementInitialState,
  requireOTP: null,
  qrCodeUrl: null,
  secret: null,
  messageMfa: null,
  mfaErrorMessage: null,
  otpMailError: null,

};

/*-------------------------------------------------LOGIN----------------------------------------------------*/
const login = (state) => {
  return {
    ...initialState,
    user: null,
    isLoading: true,
  };
};

const updateObject = (oldState, updatedValues) => {
  return { ...oldState, ...updatedValues };
};

const registerMFA = (state) => {
  return updateObject(state, { mfaErrorMessage: null, isLoading: true });
};

const registerMFASuccess = (state, action) => {
  const token = action.data?.body?.token;

  sessionStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token);
  const decodedToken = jwtDecode(token);
  sessionStorage.setItem(LOCAL_STORAGE_REF_TOKEN_KEY, decodedToken.referentielToken);
  sessionStorage.setItem(HAS_SOLDE, decodedToken.soldeNegatif);
  sessionStorage.setItem(IS_VALIDE, decodedToken.nonValide);
  sessionStorage.setItem(IS_SUSPENDU, decodedToken.suspendu);
  sessionStorage.setItem(LASTNAME, decodedToken.lastname);
  sessionStorage.setItem(FIRSTNAME, decodedToken.firstname);

  return {
    ...noContentElementInitialState,
    token,
    user: jwtDecode(token),
    referentielToken: decodedToken.referentielToken,
    hasSolde: decodedToken.soldeNegatif,
    isValide: decodedToken.nonValide,
    isSuspendu: decodedToken.suspendu,
    isLoading: false,
    isSuccessed: true,
    qrCodeUrl: null,
    secret: null,
    requireOTP: null,
  };
};

const registerMFAFailure = (state, action) => {
  return updateObject(state, {
    mfaErrorMessage: action.error,
    isLoading: false,
    // hasError: true,
  });
};

const sendOtpMail = (state) => {
  return updateObject(state, { otpMailError: null, isLoading: true });
};

const sendOtpMailSuccess = (state, action) => {
  return updateObject(state, {
    messageMfa: action.data?.message,
    isLoading: false,
  });
};

const sendOtpMailFailure = (state, action) => {
  return updateObject(state, {
    otpMailError: action.error,
    isLoading: false,
    //  hasError: true,
  });
};


const loginSuccess = (state, action) => {
  const token = action.token;
  if (!token) {
    return updateObject(state, {
      qrCodeUrl: action.qrCodeUrl || null,
      secret: action.secret || null,
      requireOTP: action.otpData?.requireOTP || null,
      messageMfa: action.otpData?.message || null,
      isLoading: false,
    });
  }
  sessionStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token);
  const decodedToken = jwtDecode(token);
  sessionStorage.setItem(LOCAL_STORAGE_REF_TOKEN_KEY, decodedToken.referentielToken);
  sessionStorage.setItem(HAS_SOLDE, decodedToken.soldeNegatif);
  sessionStorage.setItem(IS_VALIDE, decodedToken.nonValide);
  sessionStorage.setItem(IS_SUSPENDU, decodedToken.suspendu);
  sessionStorage.setItem(LASTNAME, decodedToken.lastname);
  sessionStorage.setItem(FIRSTNAME, decodedToken.firstname);
  return {
    ...noContentElementInitialState,
    token,
    user: jwtDecode(token),
    referentielToken: decodedToken.referentielToken,
    hasSolde: decodedToken.soldeNegatif,
    isValide: decodedToken.nonValide,
    isSuspendu: decodedToken.suspendu,
    isLoading: false,
    isSuccessed: true,
    qrCodeUrl: action.qrCodeUrl || null,
    secret: action.secret || null,
    requireOTP: action.otpData?.requireOTP || null,
    messageMfa: action.otpData?.message || null,

  };
};

const loginFail = (state, action) => {
  return {
    ...noContentElementInitialState,
    user: null,
    isLoading: false,
    hasError: true,
    error: action.payload,
  };
};
/*-------------------------------------------------LOGOUT----------------------------------------------------*/
const logout = () => {
  sessionStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
  sessionStorage.removeItem("welcomeShown");
  return {
    ...initialState,
    user: null,
    hasBeenLoggedOut: true,
  };
};
const logoutReinitialization = () => {
  return {
    ...initialState,
  };
};

/*************************************************************************** */
const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    /*-------------------------------------------------LOGIN----------------------------------------------------*/
    case ActionsTypes.LOGIN:
      return login(state, action);
    case ActionsTypes.LOGIN_SUCCESS:
      return loginSuccess(state, action);
    case ActionsTypes.LOGIN_FAIL:
      return loginFail(state, action);
    /*-------------------------------------------------LOGOUT----------------------------------------------------*/
    case ActionsTypes.LOGOUT:
      return logout();
    case ActionsTypes.LOGOUT_REINITIALIZATION:
      return logoutReinitialization();

    case ActionsTypes.REGISTER_MFA:
      return registerMFA(state);
    case ActionsTypes.REGISTER_MFA_SUCCESS:
      return registerMFASuccess(state, action);
    case ActionsTypes.REGISTER_MFA_FAILURE:
      return registerMFAFailure(state, action);
    case ActionsTypes.SEND_OTP_MAIL:
      return sendOtpMail(state);
    case ActionsTypes.SEND_OTP_MAIL_SUCCESS:
      return sendOtpMailSuccess(state, action);
    case ActionsTypes.SEND_OTP_MAIL_FAILURE:
      return sendOtpMailFailure(state, action);
    default:
      return state;
  }
};

export default loginReducer;
